import DefaultContentContainer from "@/components/shared/DefaultContainer/DefaultContentContainer";
import CashIcon from "@/components/icons/CashIcon";
import BankIcon from "@/components/icons/BankIcon";
import CaretIcon from "@/components/icons/CaretIcon";
import { HistoryEntry } from "@/types/state";
import { BalanceChart } from "@/components/screens/PlayingScreen/components/AccountOverviewPanel/AcountDetails/components/BalanceChart";
import AnimatedCurrencyAmount from "@/components/shared/AnimatedCurrencyAmount";
import AnimatedNumber from "@/components/shared/AnimatedCurrencyAmount";

type Props = {
    onClick?: () => void;
    value: number;
    history: HistoryEntry[];
    type: "cash" | "depot";
};
const amountDisplayedChartValues = 7; // Max characters to display for amount (including decimals and separators)
const MoneyStatDisplay = ({ onClick, history, type, value }: Props) => {
    const chartValues = history.map((entry) => entry.newValue).splice(amountDisplayedChartValues * -1);

    return (
        <DefaultContentContainer rounded="md">
            <button
                onClick={onClick}
                className="flex w-full cursor-pointer flex-col items-center justify-between gap-2 p-3"
            >
                <div className="-mt-0.5 flex justify-start items-center w-full">
                    <div className="font-bold text-white/65 mr-0.5">{type === "cash" ? "Cash" : "Depot"}</div>
                    {type === "cash" ? <CashIcon className="text-white/65" /> : <BankIcon className="text-white/65" />}
                    {onClick && (
                        <div className="ml-auto pr-1">
                            <CaretIcon />
                        </div>
                    )}
                </div>
                <div className="flex w-full justify-between items-center gap-1">
                    <div className="text-white ">
                        <AnimatedNumber value={value}/>
                        <span className="text-xs ml-0.5">€</span>
                    </div>
                    <div className="relative w-7 h-4 opacity-80">
                        <BalanceChart
                            balances={chartValues}
                            edgeFade={0.3}
                            gradientHeight={0.5}
                            strokeWidth={1.4}
                            smoothing={0.5}
                            valuesAmount={amountDisplayedChartValues}
                            animationDuration={0.5}
                        />
                    </div>
                </div>
            </button>
        </DefaultContentContainer>
    );
};

export default MoneyStatDisplay;
